'use strict';

export default class ShowMoreList {
  constructor($selector, selfInit = true) {
    this.$selector = $selector;
    this.batchCount = parseInt($selector.data('batch-count'), 10);
    this.$listWrapper = $('.show-more-list__body', $selector);
    this.$listItems = $selector.find('.show-more-list__body > div');
    this.$listToToggle = $(`div:nth-child(n+${this.batchCount+1})`, this.$listWrapper);
    this.$showMoreBtn = $selector.find('.show-more-list__show-btn a');
    this.isExpanded = false;

    if(selfInit) this.init($selector);
  }

  init() {
    this.showDefaultBatch();

    this.$showMoreBtn.on('click', (e) => {
      e.preventDefault();
      this.toggleList();
      // Update aria-expanded attribute based on visibility of items
      this.$showMoreBtn.attr('aria-expanded', this.isExpanded);
      let btnText = this.isExpanded ? 'Collapse' : 'Show more';
      $('.label', this.$showMoreBtn).text(btnText);
    });
  }

  showDefaultBatch() {
    this.$listItems.slice(0, this.batchCount).show(300);
    
    if (this.$listItems.length <= this.batchCount) {
      $('.show-more-list__show-btn', this.$selector).hide();
    }
  }

  toggleList() {
    if (this.isExpanded) {
      //Hide the list
      this.$listToToggle.fadeOut();
      this.$selector.removeClass('expanded');

      this.isExpanded = false;
    } else {
      //Show all the list
      this.$listToToggle.fadeIn();
      this.$selector.addClass('expanded');

      this.isExpanded = true;
    }
  }
}
